import { WeightUnitEnum } from '../enum/weight-unit.enum';

export class Weight {

    static format(value: any, unit: WeightUnitEnum): string {
        switch (unit) {
            case WeightUnitEnum.KG:
                return (Math.ceil(value * 100) / 100).toFixed(2);
            case WeightUnitEnum.LB:
            default:
                return (Math.ceil(value * 10) / 10).toFixed(1);
        }
    }

    static render(value: any, unit: WeightUnitEnum): string {
        return this.format(value, unit) + ' ' + this.suffix(unit);
    }

    static suffix(unit: WeightUnitEnum): string {
        switch (unit) {
            case WeightUnitEnum.KG:
                return $localize`kg`;
            case WeightUnitEnum.LB:
            default:
                return $localize`lb`;
        }
    }
}
